"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _RmaNumberImportModal = _interopRequireDefault(require("./components/RmaNumberImportModal.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _rmaNumber = require("@/api/rma-number.api");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    RmaNumberImportModal: _RmaNumberImportModal.default,
    Pagination: _index.default
  },
  data: function data() {
    return {
      total: 0,
      listLoading: false,
      data: [],
      query: {
        page: 1,
        limit: 10,
        search: ""
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.listLoading = true;
              _context.prev = 1;
              _context.next = 4;
              return _rmaNumber.rmaNumberApi.findAll(_this.query);
            case 4:
              res = _context.sent;
              console.log("fetch data", res.data);
              _this.data = res.data.data;
              _this.total = res.data.total;
            case 8:
              _context.prev = 8;
              _this.listLoading = false;
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1,, 8, 11]]);
      }))();
    },
    handleImport: function handleImport() {
      this.$refs.RmaNumberImportModal.handleOpen();
    }
  }
};